<template>
	<div class="publicBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>购买记录</li>
			</ul>
		</div>

		<a-table class="publicTable" :columns="columns" :data-source="tableData" :rowKey="res => {return res.id}"
			:pagination="pageData" @change="changePage">
			<span slot="amount" slot-scope="text" class="blue">{{ text }}</span>
			<span slot="paymentStatus" slot-scope="text" :class="stateList[text-1].class">
				{{ stateList[text-1].name }}
			</span>
		</a-table>
	</div>
</template>

<script>
	export default {
		name: 'Order',
		components: {},
		data() {
			return {
				tableLoad: false,
				tableData: [],
				columns: [{
					title: '序号',
					dataIndex: 'id',
					scopedSlots: {
						customRender: 'id'
					},
					align: 'center',
					customRender: (text, record, index) => {
						return (this.pageData.current - 1) * this.pageData.pageSize + index + 1;
					}
				}, {
					title: '面值（元）',
					dataIndex: 'amount',
					scopedSlots: {
						customRender: 'amount'
					}
				}, {
					title: '购买日期',
					dataIndex: 'paymentTime',
					scopedSlots: {
						customRender: 'paymentTime'
					}
				}, {
					title: '支付类型',
					dataIndex: 'paymentMethod',
					scopedSlots: {
						customRender: 'paymentMethod'
					}
				}, {
					title: '状态',
					dataIndex: 'paymentStatus',
					scopedSlots: {
						customRender: 'paymentStatus'
					},
				}],
				stateList:[{
					name:"待支付",
					class:"red"
				},{
					name:"已支付",
					class:"blue"
				},{
					name:"支付失败",
					class:"blank"
				},{
					name:"已取消",
					class:"blank"
				}],
				pageData: {
					current: 1,
					pageSize: 10,
					total: 0,
					showLessItems: true,
					showTotal: total => `共 ${total} 条`
				},
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			getData(){
				this.$reqToken("get", "/api/center/purchase/list",{
					pageNum: this.pageData.current,
					pageSize: this.pageData.pageSize,
				},true).then((res) => {
					this.updateTable(res);
				})
			},
			updateTable(data) {
				this.tableData = data.rows;
				this.pageData.total = data.total;
			},
			changePage(res){
				this.pageData.current = res.current;
				this.getData()
			},
		}
	}
</script>

<style scoped>

</style>